import React from 'react';
import { DeviceGroup } from 'utils/Lock/Lock';
import EditableCard from 'v2/components/EditableCard/EditableCard';
import GroupRow from './GroupRow';

export interface Group {
  id: string;
  name: string;
  isIncomplete: boolean;
  viaDeviceGroups?: DeviceGroup[];
}

interface Props {
  title: string;
  groups: Group[];
  emptyAlert?: React.ReactNode;
  editButtonId: string;
  onGroupClick: (id: string) => void;
  onEditClick: () => void;
}

const GroupCard: React.FC<Props> = ({ title, groups, emptyAlert, editButtonId, onGroupClick, onEditClick }) => {
  return (
    <EditableCard title={title} editButtonId={editButtonId} onEditClick={onEditClick} spacing={0.5}>
      {groups.map((group) => (
        <GroupRow key={group.id} group={group} onClick={() => onGroupClick(group.id)} />
      ))}
      {groups.length === 0 && emptyAlert}
    </EditableCard>
  );
};

export default GroupCard;
